import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LanguageProvider, useLanguage } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: pathname + hash,
        page_location: window.location.href,
        page_title: document.title,
        send_to: "G-N8DL87WYXD",
      });
    }
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const LangPage = ({ lang, children }) => {
  const { setLang } = useLanguage();
  useEffect(() => {
    setLang(lang);
  }, [lang, setLang]);
  return children;
};

const PAGES = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/products", element: <Products /> },
  { path: "/about", element: <About /> },
  { path: "/contact", element: <Contact /> },
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <Navbar />
          <Routes>
            {PAGES.map((pg) => (
              <Route
                key={`en${pg.path}`}
                path={pg.path}
                element={<LangPage lang="en">{pg.element}</LangPage>}
              />
            ))}
            {["es", "zh"].flatMap((lg) =>
              PAGES.map((pg) => (
                <Route
                  key={`${lg}${pg.path}`}
                  path={`/${lg}${pg.path === "/" ? "" : pg.path}`}
                  element={<LangPage lang={lg}>{pg.element}</LangPage>}
                />
              ))
            )}
            <Route path="*" element={<LangPage lang="en"><Home /></LangPage>} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
